(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/reducers/module-reducer.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/reducers/module-reducer.js');
"use strict";

const {
  createReducer
} = RTK;
const moduleReducer = createReducer({}, () => {});
setGlobal('svs.components.tipsen.store.reducers.moduleReducer', moduleReducer);

 })(window);